/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { combineEpics } from 'redux-observable';
import * as history from './history';
import * as ui from './ui';
import * as session from './session';
import * as school from './school';
import * as payment from './payment';
import * as errorMessage from './errorMessage';
import * as upload from './upload';
import * as course from './course';
import * as user from './user';
import * as theme from './theme';
import * as themeClient from './themeClient';
import * as purchase from './purchase';
import * as stash from './stash';
import * as comment from './comment';
import * as announcement from './announcement';
import * as homework from './homework';
import * as otherUser from './otherUser';
import * as event from './event';
import * as webinar from './webinar';
import * as cart from './cart';
import * as checkout from './checkout';
import * as checkoutSuccess from './checkoutSuccess';
import * as affiliateMarketing from './affiliateMarketing';
import * as quiz from './quiz';
import * as category from './category';
import * as survey from './survey';
import * as learningArea from './learningArea';
import * as learningPath from './learningPath';
import * as schoolAnnouncement from './schoolAnnouncement';
import * as knowledgeBasePage from './knowledgeBasePage';
import * as knowledgeBaseSpace from './knowledgeBaseSpace';
import * as job from './job';
import * as departments from './departments';
import * as punchIn from './punchIn';
import * as overtimeApplication from './overtimeApplication';
import * as hrCenter from './hrCenter';
import * as leaveApplication from './leaveApplication';
import * as makeUpPunchApplication from './makeUpPunchApplication';
import * as makeUpPunchRule from './makeUpPunchRule';
import * as attendance from './attendance';
import * as shift from './shift';
import * as outingPunch from './outingPunch';
import * as payroll from './payroll';
import * as qrcode from './qrcode';
import * as otp from './otp';
import * as registrationLink from './registrationLink';

const epics = [
	session,
	history,
	ui,
	school,
	payment,
	errorMessage,
	upload,
	course,
	user,
	theme,
	themeClient,
	purchase,
	stash,
	comment,
	announcement,
	homework,
	otherUser,
	event,
	webinar,
	cart,
	checkout,
	checkoutSuccess,
	affiliateMarketing,
	quiz,
	category,
	survey,
	learningArea,
	learningPath,
	schoolAnnouncement,
	knowledgeBasePage,
	knowledgeBaseSpace,
	job,
	departments,
	punchIn,
	overtimeApplication,
	hrCenter,
	leaveApplication,
	makeUpPunchApplication,
	makeUpPunchRule,
	attendance,
	shift,
	outingPunch,
	payroll,
	qrcode,
	otp,
	registrationLink,
];

const mergeEpicGroups = groups => Object.values(Object.assign({}, ...groups));

export default combineEpics(...mergeEpicGroups(epics));
